// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"472":"34d8991f","528":"ed20c341","648":"0cea52a2","772":"29d4bccb","787":"c4e7f8f9"}[chunkId] + ".chunk.js";
};